import { LoginPayload, UserGenericPayload } from "./user-generic-payload";

export class SignUpWithPasswordPayload extends LoginPayload {
    constructor(
        username: string,
        private rememberMe: boolean,
        private password: string,
        private fullName: string,
        private esignConsent: boolean,
    ) {
        super(username);
    }

    getPayload(): SignUpPayload {
        return {
            username: this.username,
            email: this.username,
            password: this.password,
            rememberMe: this.rememberMe,
            fullName: this.fullName.trim(),
            phone: '',
            esignConsent: this.esignConsent,
        };
    }
}

interface SignUpPayload extends UserGenericPayload {
    email: string;
    password: string;
    fullName: string;
    phone: string;
    esignConsent: boolean;
}
